import React from 'react';
import { Box, Typography } from '@mui/material';
// import Financialreportheader from "./Financialreportheader";
// import Financialreportfooter from "./Financialreportfooter";
// import Financialreporttable from "./FinancialReporttable";
import { UserListData } from './UserListData';
// import Financialreportdatepicker from "./Financialreportdatepicker";
import UserListheader from './UserListheader';
import UserListtable from './UserListtable';
import Searchbaruserlist from './Searchbaruserlist';
import Modaluserlist from './Modaluserlist';

const Userlist = (props) => {
  const { users, setRender, render } = props;
  let items = users;
  return (
    <>
      <Box
        sx={{
          background: '#fff',
          marginTop: 3,
          borderRadius: 2,
          border: '1px solid #e0e0ef',
        }}
      >
        {/* <Typography sx={{ background: "#F7F7F7",color:'#000',padding:2,borderBottom: "2px solid #F2F2F2",borderTopLeftRadius:8,borderTopRightRadius:8 }}>Financial Report</Typography> */}
        <Box sx={{ padding: 3 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Searchbaruserlist/>
            <Modaluserlist render={render} setRender={setRender} />
          </Box>
          <Box sx={{ overflowY: 'hidden', overflowX: 'scroll' }}>
            <UserListheader />
            {/* <Financialreportdatepicker/> */}
            {items?.map((item, index) => (
              <UserListtable
                render={render}
                setRender={setRender}
                item={item}
                number={index}
                key={index}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Userlist;
